import { render, staticRenderFns } from "./editLeaveTypePropertyGroup.vue?vue&type=template&id=836947da&"
import script from "./editLeaveTypePropertyGroup.vue?vue&type=script&lang=js&"
export * from "./editLeaveTypePropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('836947da')) {
      api.createRecord('836947da', component.options)
    } else {
      api.reload('836947da', component.options)
    }
    module.hot.accept("./editLeaveTypePropertyGroup.vue?vue&type=template&id=836947da&", function () {
      api.rerender('836947da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveTypePropertyGroup/editLeaveTypePropertyGroup.vue"
export default component.exports